import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ItemList = lazy(() => import('./pages/ItemList'));
const ItemCreate = lazy(() => import('./pages/ItemCreate'));
const ItemEdit = lazy(() => import('./pages/ItemEdit'));
const ItemView = lazy(() => import('./pages/ItemView'));
const DepartmentList = lazy(() => import('./pages/DepartmentList'));
const CategoryList = lazy(() => import('./pages/CategoryList'));
const PublisherList = lazy(() => import('./pages/PublisherList'));
const AuthorList = lazy(() => import('./pages/AuthorList'));
const BulkIsbnFetch = lazy(() => import('./pages/BulkIsbnFetch'));
const RackList = lazy(() => import('./pages/RackList'));
const TagList = lazy(() => import('./pages/TagList'));
const CurrencyList = lazy(() => import('./pages/CurrencyList'));
const LanguageList = lazy(() => import('./pages/LanguageList'));
const RegionList = lazy(() => import('./pages/RegionList'));
const GroupManager = lazy(() => import('./pages/GroupManager'));

const inventoryRoutes: RouteObject[] = [
  {
    index: true,
    element: <ItemList />,
  },
  {
    path: 'items',
    element: <ItemList />,
  },
  {
    path: 'items/create',
    element: <ItemCreate />,
  },
  {
    path: 'items/:id',
    element: <ItemView />,
  },
  {
    path: 'items/:id/edit',
    element: <ItemEdit />,
  },
  {
    path: 'departments',
    element: <DepartmentList />,
  },
  {
    path: 'categories',
    element: <CategoryList />,
  },
  {
    path: 'publishers',
    element: <PublisherList />,
  },
  {
    path: 'authors',
    element: <AuthorList />,
  },
  {
    path: 'bulk-isbn-fetch',
    element: <BulkIsbnFetch />,
  },
  {
    path: 'racks',
    element: <RackList />,
  },
  {
    path: 'tags',
    element: <TagList />,
  },
  {
    path: 'currencies',
    element: <CurrencyList />,
  },
  {
    path: 'languages',
    element: <LanguageList />,
  },
  {
    path: 'regions',
    element: <RegionList />,
  },
  {
    path: 'groups',
    element: <GroupManager />,
  },
];

export default inventoryRoutes;
